module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAOCAYAAADNGCeJAAAAAXNSR0IArs4c6QAAANxJREFUOE+9kzEOgkAQRd8kFN5IL2BvYWOlR9CYGKFRG7Q1NnZibPQGHsGT2NsZYzIGZAFxCSQSqRZm/ttHdlYwz1wdHuyALtBIvpcvnihnbvQk6XW1gzDmSptA7uWMuOMtcQAuKczTWVT2ZWEFudpnKXtrLc5Wh3mq+JL2Z6mVYcbIwGyGHzBXm0CAsMWXdbRpHmJgNmgCc3UTnaAwwpdjYp8PF72HgS+YMmQlp99gYXqiLZxoxtLfnOqAlQQUGZn6h5lRKRqNPDQLyWX/PBpmd5tRoVmt16mGi/4CU7ixeaSLbNsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/housework/voice.png
// module id = EbFm
// module chunks = 5